/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Portalsignin_Link_Sent_BodyInputs */

const en_portalsignin_link_sent_body = /** @type {(inputs: Portalsignin_Link_Sent_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We sent a sign-in link to ${i?.email}. It works once and expires in a few minutes.`)
};

/**
* | output |
* | --- |
* | "We sent a sign-in link to {email}. It works once and expires in a few minutes." |
*
* @param {Portalsignin_Link_Sent_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portalsignin_link_sent_body = /** @type {((inputs: Portalsignin_Link_Sent_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Link_Sent_BodyInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_portalsignin_link_sent_body(inputs)
});